module.exports = __webpack_public_path__ + "media/images/icons/payment_third_step-da2701b485a61e0800c7aad6c811d7b6.svg";